


















































































import { defineComponent } from "@vue/composition-api";

import DomainComponent from "./DomainComponent.vue";
import collapse from "./collapse";
import { injectStrict } from "@/lib/utils";
import { RubricStoreKey } from "@/store/StoreInjectionKeys";

export default defineComponent({
  components: { DomainComponent },
  setup(props) {
    const { showCollapse, toggleCollapse } = collapse();
    const rubricStore = injectStrict(RubricStoreKey);

    return {
      rubricStore,
      showCollapse,
      toggleCollapse,
    };
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    domainIndex: {
      type: Number,
      required: true
    },
    domainCount: {
      type: Number,
      required: true
    }
  }
});
